/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

/*
	Service helper that holds the objects wanting to run something when the app starts.

	The functions you should have attached to your objects correspond to PHASES.
	eg if you want to listen for when everything has been loaded, make sure you have a function called "whenReady".

	Example usage:
	var startupObj = {
		whenHostReady: function() {
			// your code here
		}
	};

	iaw.startup.add(startupObj);
*/
var iaw = iaw || {};
iaw.startup = {
	PHASES: {
		Doc: 'whenDocReady', // after the document finishes loading, before host data is loaded
		Host: 'whenHostReady', // after host data has been loaded
		Done: 'whenReady' // after everything has been loaded
	},

	_objs: [],

	/*
		Pass in the object that holds the (public) function(s) to be called during the startup sequence.
	*/
	add: function(startupObj) {
		var haveCB = false;
		for (var p in this.PHASES) {
			if (startupObj[this.PHASES[p]]) {
				haveCB = true;
				break;
			}
		}
		if (!haveCB) {
			throw new Error('[iaw.init] Add at least one init callback before adding to startup sequence.');
		}
		this._objs.push(startupObj);
	},

	remove: function(startupObj) {
		var i = this._objs.indexOf(startupObj);
		if (i === -1) return;
		this._objs.splice(i, 1);
		console.log(this._objs);
	},

	/*
		Cycles through all objects to call their functions if they exist. No arguments are passed.
		@private
	*/
	run: function(phase) {
		var i, o;
		// console.log('[Startup] Running '+phase);
		for (i = 0; i < this._objs.length; i++) {
			o = this._objs[i];
			if (o[phase]) {
				o[phase].call(o);
			}
		}
	}
};
